import { RETAIL_ONLY_CART } from 'constants/cartTypes';

import marketplace from 'cfg/marketplace.json';
import {
  canPurchaseHavePromos,
  isNonRetailOnlyCart
} from 'helpers/CheckoutUtils';
import { toUSD } from 'helpers/NumberFormats';
import styles from 'styles/components/checkout/caap/payment/paymentlist/purchasepromos.scss';

const { name } = marketplace;

const PurchasePromos = componentParams => {
  const {
    cartType,
    eligibleBalances
  } = componentParams;

  if (!eligibleBalances) {
    return null;
  }

  const { coupons, couponBalance, gcBalance } = eligibleBalances;

  return (
    <div>
      {
        gcBalance && cartType === RETAIL_ONLY_CART
          ? <div>
            {`${toUSD(gcBalance)} Gift Card Balance`}
          </div>
          : null
      }

      {
        couponBalance && canPurchaseHavePromos(cartType)
          ? coupons.map((promo, index) => (
            <div key={`promo-${index}`}>
              {`${toUSD(promo.amountUsed)} ${promo.description}`}
            </div>
          ))
          : null
      }

      {
        // TODO: https://github01.zappos.net/mweb/marty/issues/3357
        // replace couponBalance with proper named variable, as this will never trigger right now
        couponBalance && !canPurchaseHavePromos(cartType)
          ? <div className={styles.unappliedBalance}>
            {`Your ${toUSD(couponBalance)} promo balance can't be applied to orders that contain ${name} gift cards.`}
          </div>
          : null
      }

      {
        gcBalance && isNonRetailOnlyCart(cartType)
          ? <div className={styles.unappliedBalance}>
            {`Your ${toUSD(gcBalance)} gift card balance can't be applied to orders that contain ${name} gift cards.`}
          </div>
          : null
      }
    </div>
  );
};

export default PurchasePromos;
